/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable no-console */
import React, { Component } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Grid, Row, Column, Keyboard, Button, Heading, Form, FormInput, cls, HeaderCompound, TranslationID } from 'packages/components';
import { connect } from 'react-redux';
import Translator from '../../requests/apa/Translator';
import { autobind } from 'packages/core/lib';
import { PAYMENT_CODE } from '../utils/constants';
import { showModal, AAF_MODAL_SUCCESS_SUSCRIPTION } from '../../actions/modal';
import { regExp } from 'packages/components/lib/Input/utils';
import { getwWorkflowstart, parseWorkFlowStart } from '../Checkout/utils'
import { IWorkflowstart } from '../Checkout';
import { TransactionDetailType } from 'packages/components/lib/TransactionDetail';
import { apiPaywayConfirm, onPaymetSuccess, showError, getWorkflow, setInitialFocus, onFocusElement, handleTypeModal, filterInputValue, redirectPlayerOneClic, isModalHide } from '../utils/Utils';
import UtilsPagos from "../../utils/payway/UtilsPagos";
import Assets from '../../requests/apa/Asset';
import Device from '../../devices/device';
import DeviceStorage from '../../components/DeviceStorage/DeviceStorage';
import Spinner from '../../components/Spinner';
import './_styles.scss';
import { setMetricsEvent } from '../../actions/metrics';
import Utils, { enablePaymentMethodExperience } from '../../utils/Utils';
import { SUSCRIPCION_CLARO_VIDEO_REGISTRO, EXITOSO_MENSUAL_ANUAL_METODO_DE_PAGO, METODO_DE_PAGO, CANCELAR_MEDIO_PAGO, COMPONENTE_TICKER, ADD_ON_REGISTRO, COMPONENT_SUSCRIPCION, CLAROVIDEO, COMPRAS_VCARD, ADD_ON_VCARD, ADD_ON_TV, COMPONENT_REGISTRO_EXITOSO, QUE_INCLUYE, LABEL_PRUEBA_30_DIAS, LABEL_SUSCRIBETE_AHORA } from '../../authentication/utils/constansMetrics';
import {GA4} from 'src/utils/trackers/GA4';
import {PAYMENT_METHOD_PROMO_CODE} from 'src/utils/trackers/GA4Constants';
import store from 'src/store';

interface ICodeState {
    code: string;
    errorFromBackend: string;
    valid: boolean;
    showTooltipSuccess: boolean;
    pbi: any;
    worflowstart: IWorkflowstart;
    selectedPaymentMethod: string;
    type: number;
    isLoading: boolean;
    isApiError: boolean;
}

class PaymentCode extends Component<RouteComponentProps, ICodeState> {
    public textNext: string = Translator.get('promogate_access_option_button_next', 'SIGUIENTE');
    public textCancel: string = Translator.get('promogate_access_option_button_cancel', 'CANCELAR');
    public titleForm: string = Translator.get('promogate_access_title_label', false);
    public subtitleForm: string = Translator.get('promogate_access_subtitle_label', false);
    private isValidForm: boolean;
    public keys = (Device.getDevice() && Device.getDevice().getKeys()) || null;
    private translations: Record<TranslationID, string>;
    private from: string = '';
    private trial: any;

    constructor(props: RouteComponentProps) {
        super(props);
        const { location: { state = {} } = {} } = props || {};
        this.from = state?.from;
        this.state = {
            code: '',
            errorFromBackend: '',
            valid: false,
            showTooltipSuccess: false,
            pbi: {},
            worflowstart: {
                hasSavedPayway: false,
                hasUserSusc: '',
                newWorkflow: '',
                list: [],
                selectedPaymentMethod: ''
            },
            selectedPaymentMethod: '',
            type: 0,
            isLoading: false,
            isApiError: false
        };
        this.trial = this.props.location.state.trial.period;
        this.translations = {
            'form_tooltip_empty_label_validation': Translator.get('form_tooltip_empty_label_validation', 'Debes completar este campo.'),
        };
    }

    public componentDidMount(): void {
        document && document.removeEventListener('keydown', this.onKeyPress, true);
        document && document.addEventListener('keydown', this.onKeyPress, true);
        const selectedPaymentMethod = this.props.location.state.method;
        const { location: { state: { type, pbi, worflowstart } } } = this.props;
        const { user } = store.getState() || {};
        
        if (!user.isLoggedIn) {
            this.sendAnonymousUserToRegister()
        } else if (pbi && worflowstart && type) {
            this.setState({ pbi, worflowstart, selectedPaymentMethod, type });
        } else {
            this.getData();
        }
        if (isModalHide()) {
            setInitialFocus('.aaf_form-group-input-element .aaf_focusable', false);
        }
    }

    public componentWillUnmount(): void {
        document && document.removeEventListener('keydown', this.onKeyPress, true);
    }

    private sendAnonymousUserToRegister() {
        const { history, location: { state: pbi = {} } = {} } = this.props;
        history.push(`/register`, { ...pbi , from: 'promoGate'});
    }

    private getData(): void {

        const { linkworkflowstart, offerid, groupId, method } = this.props.location.state;
        const {location: {state}} = this.props;
        const { history } = this.props;
        getwWorkflowstart(linkworkflowstart, groupId, offerid).then((resp) => {
            const ws: IWorkflowstart = parseWorkFlowStart(resp.response);
            const selectedPaymentMethod: string = method ? method : ws.selectedPaymentMethod;
            this.setState({ worflowstart: ws, isLoading: false, pbi: {...state}, selectedPaymentMethod: selectedPaymentMethod, type: this.getTransactionType() });
        }).catch((err) => {
            this.setState({ isLoading: false }, () => {
                showError(err, history.goBack());
            });
        });
    }

    @autobind
    private getTransactionType(): TransactionDetailType {

        let {pbi: { oneoffertype = '', producttype = '' } = {}} = this.props.location.state || this.state || {};

        if(!oneoffertype) {
            let _oneoffertype =  this.props.location.state.oneoffertype ? this.props.location.state.oneoffertype : '';

            if(!oneoffertype) {
                oneoffertype = _oneoffertype;
            }
        }

        if (oneoffertype.toLowerCase().includes('buy')) {
            if (producttype.toLowerCase().includes('season')) {
                return TransactionDetailType.BUY_SEASON;
            } else if (producttype.toLowerCase().includes('episode')) {
                return TransactionDetailType.BUY_EPISODE;
            } else {
                return TransactionDetailType.BUY_MOVIE;
            }
        } else if (oneoffertype.toLowerCase().includes('rent')) {
            return TransactionDetailType.RENT_MOVIE;
        }
        else if (oneoffertype.toLowerCase().includes('subscrition')) {
            return TransactionDetailType.SUSCRIPTION;
        }
        else {
            throw new Error('[AAF Payment] Tipo de transaccion no asociado');
        }
    }

    @autobind
    private handleChange(value: string): void {
        let { valid, showTooltipSuccess, errorFromBackend, isApiError } = this.state;
        this.isValidForm = value !== '';
        if (value === '' || regExp.hasNumberCode.test(value) || (value.length === 21 && !isApiError)) {
            valid = false;
            showTooltipSuccess = false;
            errorFromBackend = '';
        }
        const filteredValue = filterInputValue(value, 'validation_code');
        this.setState({ code: filteredValue, valid, showTooltipSuccess, errorFromBackend });
    }

    @autobind
    private handlePlay(groupId: string, payway_token: string, islive: boolean) {
        if (groupId) {
            redirectPlayerOneClic(groupId, islive, payway_token, () => {
                this.handleVCard(groupId);
            })
        }
    }

    @autobind
    private handleVCard(groupId: string) {
        if (groupId) {
            const { history } = this.props;
            history.replace(`/vcard/${groupId}`);
        }
    }

    @autobind
    private showTicket(resp: any, groupId: string, islive: boolean) {
        const { showModal } = this.props;
        const { type, worflowstart: { contentInfo }, pbi, pbi: { producttype, currency, price, family, periodicity, frequency }, selectedPaymentMethod } = this.state;
        const region = DeviceStorage.getItem('region');
        const { response: { end_date: { day = '', month = '', year = '' } = {}, payway_token = '' } = {} } = resp || {};
        const next_pay = `${day} ${Translator.get(month)} ${year}`;

        const data: any = {
            pbi,
            total: UtilsPagos.getTotalAndPeriodicity(currency, price, periodicity),
            duration: `${Translator.get(periodicity, '')}`,
            frequency: frequency,
            days: Translator.get(`bonus_${producttype}`),
            content: Translator.get(`Ticket_Transaccion_TextoDescripcion_${producttype}`, ''),
            payment_method: Translator.get(`ticket_subscription_${selectedPaymentMethod}_label`, ''),
            payment_method_key: selectedPaymentMethod,
            img_largeSub: Assets.get(`${region}_transactional_${family}_poster`, ''),
            img_large: contentInfo?.contentImageMedium,
            providerImage: Assets.get(`transactional_${family}_logo`),
            title: contentInfo?.contentTitle || '',
            type: type,
            from: this.from
        };

        const transactionType = this.getTransactionType();
        if (transactionType !== TransactionDetailType.RENT_MOVIE) {
            data.next_pay = next_pay
        }

        const modal = {
            modalType: AAF_MODAL_SUCCESS_SUSCRIPTION,
            modalProps: {
                data: handleTypeModal({ ...data }),
                handlePlay: () => this.from ? this.handleAddOn(resp) : this.handlePlay(groupId, payway_token, islive),
                handleVCard: () => this.handleVCard(groupId),
                callback: () => {
                    setInitialFocus('.aaf_form-group-input-element .aaf_focusable');
                },
                payment_methods_experience: enablePaymentMethodExperience()
            }
        };
        showModal(modal);
    }

    private getPlanName(producttype: any){
        return producttype.replace('_', ' ')
    }

    @autobind
    private sendGA4Metric() {
        const gA4 = new GA4();
        gA4.sendAddPaymentMethodEvent(PAYMENT_METHOD_PROMO_CODE);
    }

    private setMetricsSuscription(pbi: any, wfs: any){
        if(!pbi.isSubscription) return;
        const productType = wfs.producttype.split('_');
        const eventLabel = this.getPlanName(pbi.producttype);

        const metricsHistory = this.props.location.state.metricsHistory;
        let eventActionText = '';
        if(metricsHistory){
            eventActionText = metricsHistory.toLowerCase().includes('vcard') ? ADD_ON_VCARD : (metricsHistory.toLowerCase().includes('tv') ? ADD_ON_TV : ADD_ON_REGISTRO) ;
        } else{
            eventActionText = ADD_ON_REGISTRO;
        }

        if(pbi.family === CLAROVIDEO) {
            Utils.sendMetric(this.props,  SUSCRIPCION_CLARO_VIDEO_REGISTRO, EXITOSO_MENSUAL_ANUAL_METODO_DE_PAGO.concat(productType[1].toLowerCase()).concat(' - ',  wfs.gatewaytext.toLowerCase()), COMPONENT_SUSCRIPCION);
        }else {
            Utils.sendMetric(this.props,  eventActionText, EXITOSO_MENSUAL_ANUAL_METODO_DE_PAGO.concat(eventLabel.toLowerCase()).concat(' - ',  wfs.gatewaytext.toLowerCase()), COMPONENT_SUSCRIPCION);
        }
    }

    private setMetricsSeason(pbi: any, wfs: any){
        const isSeason =  wfs.producttype.toLowerCase().indexOf('season') > 0 ? true : false;
        const isEpisode =  wfs.producttype.toLowerCase().indexOf('episode') > 0 ? true : false;
        const episode = pbi.oneofferdesc.split(' ');
        const { worflowstart: {contentInfo}, } = this.state;
        if(contentInfo){
            if(isSeason) {
                Utils.sendMetric(this.props,  (contentInfo.contentTitle.toLowerCase()).concat(' - ',  wfs?.gatewaytext.toLowerCase()),contentInfo.contentOriginalTitle.toLowerCase(), COMPRAS_VCARD);
            }else if(isEpisode) {
                Utils.sendMetric(this.props,  (`${episode[1]} ' ' ${episode[2]}`).concat(' - ',  wfs?.gatewaytext.toLowerCase()),contentInfo.contentOriginalTitle.toLowerCase(), COMPRAS_VCARD);
            } else {
                Utils.sendMetric(this.props,  (pbi.oneofferdesc.toLowerCase()).concat(' - ',  wfs?.gatewaytext.toLowerCase()),contentInfo.contentTitle.toLowerCase(), COMPRAS_VCARD);
            }
        }
    }

    private handleSubmit = (): void => {
        const { worflowstart, code, pbi, pbi: { isSubscription }, selectedPaymentMethod } = this.state;
        let { valid, showTooltipSuccess } = this.state;
        const wfs = getWorkflow(selectedPaymentMethod, worflowstart);
        let cb = isSubscription ? (resp: object) => this.redirectAddon(resp) : (resp: object) => this.redirectVCard(resp);
        this.setMetricsSuscription(pbi, wfs);
        if (code.length <= 1) {
            this.setState({ showTooltipSuccess, errorFromBackend: this.translations['form_tooltip_empty_label_validation'],  isApiError: false });
        } else {
            this.setState({ isLoading: true });
            this.sendGA4Metric();
            apiPaywayConfirm({
                pbi,
                wfs,
                formParams: { pincode: code, payway: selectedPaymentMethod }
            })
                .then((resp) => {
                    this.addMetrics(this.trial);
                    this.setMetricsSeason(pbi, wfs);
                    onPaymetSuccess(resp, pbi, wfs, selectedPaymentMethod, cb);
                    this.setState({ isLoading: false});
                })
                .catch((err) => {
                    this.setState({ isLoading: false, errorFromBackend: Translator.get(err.code, ''), isApiError: true });
                });
        }
        this.setState({ valid, showTooltipSuccess });
    };

    private addMetrics(trial: string){
        const {location:{state}} = this.props
        if(trial !== undefined){
            if(trial != '') {
                Utils.sendMetric(this.props,  QUE_INCLUYE, `${this.trial} ${LABEL_PRUEBA_30_DIAS}`, COMPONENT_REGISTRO_EXITOSO);
            }else {
                Utils.sendMetric(this.props,  QUE_INCLUYE, ` ${state.method} ${LABEL_SUSCRIBETE_AHORA}`, COMPONENT_REGISTRO_EXITOSO);
            }
        }
    }

    private redirectAddon(resp: any): void {
        const { pbi: { groupId = '', oneoffertype = '', islive = false }, worflowstart: { selectedPaymentMethod } } = this.state;
        const isOneClicFlow = groupId === '' ? false : true;
        const oneClicKey = `${oneoffertype}_${selectedPaymentMethod}`;
        if (UtilsPagos.oneClicBuyHiddeConfirm(isOneClicFlow, oneClicKey)) {
            if (UtilsPagos.oneClicBuyRedirectPlayer(isOneClicFlow, oneClicKey)) {
                const { response: { payway_token = '' } = {} } = resp || {};
                this.handlePlay(groupId, payway_token, islive);
            }
            else {
                // este caso aplica cuando no se tiene activado el one clic muestra modal de compra exitosa
                this.showTicket(resp, groupId, islive);
            }
        } else {
            // aplica para plan selector y vcard cuando no hay one clic
            this.showTicket(resp, groupId, islive);
        }
    }

    private redirectVCard(resp?: any): void {
        const { pbi: { groupId = '', oneoffertype = '', islive = false }, worflowstart: { selectedPaymentMethod } } = this.state;
        const isOneClicFlow = groupId === '' ? false : true;
        const oneClicKey = `${oneoffertype}_${selectedPaymentMethod}`;
        if (UtilsPagos.oneClicBuyHiddeConfirm(isOneClicFlow, oneClicKey)) {
            if (UtilsPagos.oneClicBuyRedirectPlayer(isOneClicFlow, oneClicKey)) {
                setTimeout(() => {
                    const { history } = this.props;
                    const nav = Utils.getApaMetadataKey('links_nav_configuration', Utils.mock_links_nav_configuration());
                    if (islive) {
                        if(nav && nav.home) {
                            history.replace(`/node/${nav.home}`);
                        }
                    }
                    else if (groupId) {
                        this.handleVCard(groupId);
                    }
                }, 0);
            }
            else {
                // este caso aplica cuando no se tiene activado el one clic muestra modal de compra exitosa
                this.showTicket(resp, groupId, islive);
            }
        } else {
            // aplica para plan selector y vcard cuando no hay one clic
            this.showTicket(resp, groupId, islive);
        }
    }

    private handleAddOn(resp: any) {
        const { history, nodes } = this.props;
        const { response: { node_id = '' } = {} } = resp || {};
        let nodeString: string = '';
        const filterNodes = nodes.filter((value: any) => value.code === 'playandgo');
        const resultChilds = filterNodes.map((res: any) => {
            const childsValue = res.childs;
            return childsValue;
        });

        for (let index = 0; index < resultChilds.length; index++) {
            const element = resultChilds[index];
            element.map((resId: any) => {
                if (resId.id === node_id) {
                    return nodeString = resId.code;
                }
            });
        }

        this.setState({ isLoading: false });
        history.replace(`/node/${nodeString ? nodeString : 'homeuser'}`);
    }

    private hadleCancel = (): void => {
        const { worflowstart, selectedPaymentMethod } = this.state;
        const methodDescription = worflowstart.list.find(list => list.gateway === selectedPaymentMethod);
        Utils.sendMetric(this.props,  METODO_DE_PAGO, `${methodDescription?.gatewaytext?.toLowerCase()} - ${CANCELAR_MEDIO_PAGO}`, COMPONENTE_TICKER);
        const { history } = this.props;
        history.goBack();
    };

    @autobind
    private handleBack(): void {
        const { history } = this.props;
        history.goBack();
    }

    @autobind
    private onKeyPress(e: any): void {
        const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
        if (currentKey === 'YELLOW') {
            this.handleBack();
        }
    }

    @autobind
    private onFocus(): void {
        onFocusElement([{ id: 'promotionInput' }]);
    }

    public render(): JSX.Element {
        const { valid, showTooltipSuccess, errorFromBackend, isLoading, code } = this.state;
        if (isLoading) return <Spinner className ={cls(`${PAYMENT_CODE}-spinner`)} loadingMessage='' />;
        return (
            <Grid className={Device.getDevice().getPlatform()}>
                <HeaderCompound
                    disabled
                    align='right'
                    onClick={this.handleBack}
                    textBack={Translator.get('top_head_option_button_back', 'REGRESAR')}
                    icon={`${Assets.get('top_head_option_back')}`}
                    onFocus={this.onFocus}
                />
                <Row>
                    <Column lg={12}>
                        <Heading size={2} className={cls(`${PAYMENT_CODE}-title`)}>
                            {this.from && this.from === 'plan-selector' ? Translator.get('top_head_step_3_label', 'PASO 3 DE 3') : ''}
                        </Heading>
                    </Column>
                </Row>
                <Row>
                    <Form id="payment-code-form">
                        <Column lg={6} className={cls(`${PAYMENT_CODE}-column-keyboard`)}>
                            <Keyboard id="Keyboard" onFocus={this.onFocus} filteredFuncion={filterInputValue} />
                        </Column>
                        <Column lg={6} className={cls(`${PAYMENT_CODE}-column-inputs`)}>
                            <Row className={cls(`${PAYMENT_CODE}-row-inputs`)}>
                                <Column lg={12}>
                                    {this.titleForm &&
                                        <Heading size={1} className={cls(`${PAYMENT_CODE}-title-form`)}>
                                            {this.titleForm}
                                        </Heading>
                                    }
                                </Column>
                                <Column lg={12} className={`${PAYMENT_CODE}-subtitle`}>
                                    {this.subtitleForm &&
                                    <span>{this.subtitleForm}</span>
                                    }
                                </Column>
                                <Row className={cls(`${PAYMENT_CODE}-column-input`)}>
                                    <Column lg={12}>
                                        <FormInput
                                            id="promotionInput"
                                            focusWhenMount
                                            type="validation_code"
                                            name="code"
                                            placeholder={Translator.get(
                                                'promogate_access_placeHolder_textfield',
                                                ''
                                            )}
                                            onChange={this.handleChange}
                                            errorFromBackend={errorFromBackend}
                                            showTooltipSuccess={showTooltipSuccess}
                                            validInput={valid}
                                            maxLength={21}
                                            value={code}
                                        />
                                    </Column>
                                </Row>
                                <Column lg={12}>
                                    <Button
                                        activate
                                        type="button"
                                        variant="primary"
                                        disabled={!this.isValidForm}
                                        className={cls(`focusable`, `${PAYMENT_CODE}-button-next`)}
                                        onClick={this.handleSubmit}
                                        block
                                        onFocus={this.onFocus}
                                    >
                                        {this.textNext}
                                    </Button>
                                </Column>
                                <Column lg={12} className={cls(`${PAYMENT_CODE}-column-next`)}>
                                    <Button
                                        activate
                                        type="button"
                                        className={cls(`focusable`, `${PAYMENT_CODE}-button-cancel`)}
                                        onClick={this.hadleCancel}
                                        block
                                        onFocus={this.onFocus}
                                    >
                                        {this.textCancel}
                                    </Button>
                                </Column>
                            </Row>
                        </Column>
                    </Form>
                </Row>
            </Grid>
        );
    }
}

const mapDispatchToProps = {
    showModal,
    setMetricsEvent
};

export default connect(null, mapDispatchToProps)(PaymentCode);



// WEBPACK FOOTER //
// ./src/payments/PromoGate/index.tsx